import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import TutoringV2Component from './components/TutoringV2Component';

function TutoringV2() {
  return renderComponent(<TutoringV2Component />);
}

export default TutoringV2;
